type JsonLdProps = {
  id?: string
  schema: object | object[]
}

export const JsonLd = ({ id, schema }: JsonLdProps) => (
  <script
    {...(id ? { id } : {})}
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
  />
)
